// @ts-nocheck
(function () {
  const root = document.getElementById("LoginPage");
  if (!root) return;

  const {
    LOGIN,
    LOGIN_OTP_REQUEST,
    LOGIN_OTP_VERIFY,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
  } = window.AccountEndpoints;
  const { apiPost } = window.AccountHttp;
  const {
    GENERIC,
    VALIDATION,
    OTP,
    LOGIN: LOGIN_MSG,
    RESET_PASSWORD: RESET_MSG,
    ACCOUNT_UI,
    friendlyError,
  } = window.AccountMessages;

  const accountRedirectUrl =
    root.getAttribute("data-account-redirect-url") || "/pages/my-account";

  function base64EncodeUtf8(str) {
    const bytes = new TextEncoder().encode(str);
    let binary = "";
    bytes.forEach(function (b) {
      binary += String.fromCharCode(b);
    });
    return btoa(binary);
  }

  function showStep(stepName) {
    root.querySelectorAll("[data-step]").forEach(function (stepEl) {
      stepEl.hidden = stepEl.getAttribute("data-step") !== stepName;
    });
  }

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function hideError(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = "";
  }

  function showSuccess(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function hideSuccess(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = "";
  }

  function setBusy(button, busy, busyLabel) {
    if (!button) return;
    button.disabled = busy;
    const labelEl = button.querySelector("[data-btn-label]");
    if (busy) {
      button.dataset.originalLabel = labelEl
        ? labelEl.textContent
        : button.textContent;
      if (labelEl) labelEl.textContent = busyLabel || ACCOUNT_UI.PLEASE_WAIT;
    } else if (labelEl && button.dataset.originalLabel) {
      labelEl.textContent = button.dataset.originalLabel;
    }
  }

  // Keeps a submit button disabled until all of its linked inputs have a value
  function wireEnableOnFill(button, inputs) {
    if (!button || !inputs.length) return function () {};
    function update() {
      const filled = inputs.every(function (input) {
        return input && input.value.trim().length > 0;
      });
      button.disabled = !filled;
    }
    inputs.forEach(function (input) {
      if (input) input.addEventListener("input", update);
    });
    update();
    return update;
  }

  // Leading zeros are allowed in the input (e.g. 07…), no length limit.
  function digitsOnly(input) {
    input.addEventListener("input", function () {
      this.value = this.value.replace(/\D/g, "");
    });

    input.addEventListener("keydown", function (e) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Home",
        "End",
      ];

    const isShortcut =
      (e.ctrlKey || e.metaKey) &&
      ["a", "c", "v", "x", "z"].includes(e.key.toLowerCase());

      if (allowedKeys.includes(e.key) || isShortcut) {
        return;
      }
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    });

    input.addEventListener("paste", function (e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData)
        .getData("text")
        .replace(/\D/g, "");
      this.value = pasted;
      this.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }

  function wireCountryPhoneSync(selectEl, displayEl, phoneInput) {
    if (!selectEl) return;

    function apply() {
      const opt = selectEl.options[selectEl.selectedIndex];

      if (displayEl) {
        displayEl.textContent =
          (opt && opt.getAttribute("data-label")) ||
          (opt && opt.textContent) ||
          "";
      }

      if (phoneInput) phoneInput.setCustomValidity("");
    }

    apply();
    selectEl.addEventListener("change", apply);
  }

  // Digits only, and at least one non-zero digit once leading zeros go.
  function isValidPhoneNumber(input) {
    return /^\d+$/.test(input.value) && /[1-9]/.test(input.value);
  }

  function invalidPhoneMessage() {
    return VALIDATION.INVALID_PHONE_NUMBER;
  }

  // Country code + number, with any leading zeros dropped from the number:
  function buildPhone(selectEl, input) {
    return (
      (selectEl ? selectEl.value : "") + input.value.replace(/^0+/, "")
    );
  }

  function makeOtpBoxGroup(container, hiddenInput, onChange) {
    const boxes = Array.prototype.slice.call(
      container.querySelectorAll("[data-otp-box]"),
    );

    function updateHidden() {
      if (hiddenInput) {
        hiddenInput.value = boxes
          .map(function (box) {
            return box.value;
          })
          .join("");
      }
      if (onChange) onChange();
    }

    function focusBox(index) {
      if (boxes[index]) boxes[index].focus();
    }

    function reset() {
      boxes.forEach(function (box) {
        box.value = "";
      });
      updateHidden();
    }

    boxes.forEach(function (box, index) {
      box.addEventListener("input", function () {
        this.value = this.value.replace(/\D/g, "").slice(0, 1);
        updateHidden();
        if (this.value && index < boxes.length - 1) {
          focusBox(index + 1);
        }
      });

      box.addEventListener("keydown", function (e) {
        if (e.key === "Backspace" && !this.value && index > 0) {
          focusBox(index - 1);
        }
      });

      box.addEventListener("paste", function (e) {
        e.preventDefault();
        const pasted = (e.clipboardData || window.clipboardData)
          .getData("text")
          .replace(/\D/g, "")
          .slice(0, boxes.length);
        pasted.split("").forEach(function (digit, i) {
          if (boxes[i]) boxes[i].value = digit;
        });
        updateHidden();
        focusBox(Math.min(pasted.length, boxes.length - 1));
      });
    });

    return {
      boxes: boxes,
      updateHidden: updateHidden,
      focusBox: focusBox,
      reset: reset,
    };
  }

  // How long the customer must wait before requesting another OTP.
  const RESEND_COOLDOWN_MS = 60 * 1000;
  const { startResendCountdown } = window.AccountUI;

  const flow = {
    phone: "",
    otp: "",
    mode: "forgot",
  };

  let pendingSetupPhone = null;

  // STEP: LOGIN

  const loginForm = document.getElementById("LoginForm");
  const loginPhoneInput = document.getElementById("CustomerPhone");
  const loginPasswordInput = document.getElementById("CustomerPassword");
  const loginCountrySelect = document.getElementById("CountryCode");
  const loginErrorBox = root.querySelector(
    '[data-step="login"] [data-login-error]',
  );
  const loginSubmitBtn = root.querySelector(
    '[data-step="login"] [data-login-submit]',
  );
  const passwordFieldWrapper = root.querySelector(
    '[data-step="login"] [data-login-password-field]',
  );
  const loginChangeNumberBtn = root.querySelector(
    '[data-action="change-login-number"]',
  );

  function updateLoginSubmitState() {
    if (!loginSubmitBtn) return;
    const phoneFilled =
      !!loginPhoneInput && loginPhoneInput.value.trim().length > 0;
    const passwordFilled =
      flow.mode === "setup" ||
      (!!loginPasswordInput && loginPasswordInput.value.trim().length > 0);
    loginSubmitBtn.disabled = !(phoneFilled && passwordFilled);
  }

  function clearLoginPassword() {
    if (!loginPasswordInput) return;
    loginPasswordInput.value = "";
    loginPasswordInput.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function enterPasswordSetupMode(phone) {
    flow.mode = "setup";
    pendingSetupPhone = phone;

    if (passwordFieldWrapper) passwordFieldWrapper.hidden = true;
    clearLoginPassword();
    loginPasswordInput.removeAttribute("required");
    loginPhoneInput.setAttribute("readonly", "");
    if (loginChangeNumberBtn) loginChangeNumberBtn.hidden = false;

    if (loginSubmitBtn) {
      const labelEl = loginSubmitBtn.querySelector("[data-btn-label]");
      if (labelEl) labelEl.textContent = ACCOUNT_UI.SET_PASSWORD;
      loginSubmitBtn.dataset.originalLabel = ACCOUNT_UI.SET_PASSWORD;
    }
    updateLoginSubmitState();
  }

  function resetPasswordSetupState() {
    if (flow.mode !== "setup") return;

    flow.mode = "forgot";
    pendingSetupPhone = null;
    clearLoginPassword();

    if (passwordFieldWrapper) passwordFieldWrapper.hidden = false;
    loginPasswordInput.setAttribute("required", "");
    loginPhoneInput.removeAttribute("readonly");
    if (loginChangeNumberBtn) loginChangeNumberBtn.hidden = true;

    if (loginSubmitBtn) {
      const labelEl = loginSubmitBtn.querySelector("[data-btn-label]");
      if (labelEl) labelEl.textContent = ACCOUNT_UI.LOG_ME_IN;
      loginSubmitBtn.dataset.originalLabel = ACCOUNT_UI.LOG_ME_IN;
    }
    updateLoginSubmitState();
  }

  // Leave password-setup mode and return to the normal phone + password login.
  if (loginChangeNumberBtn) {
    loginChangeNumberBtn.addEventListener("click", function () {
      hideError(loginErrorBox);
      resetPasswordSetupState();
      loginPhoneInput.focus();
    });
  }

  if (loginPhoneInput)
    loginPhoneInput.addEventListener("input", updateLoginSubmitState);
  if (loginPasswordInput)
    loginPasswordInput.addEventListener("input", updateLoginSubmitState);
  updateLoginSubmitState();

  if (loginPhoneInput) digitsOnly(loginPhoneInput);
  wireCountryPhoneSync(
    loginCountrySelect,
    root.querySelector('[data-step="login"] [data-country-display]'),
    loginPhoneInput,
  );

  if (loginForm) {
    loginForm.addEventListener("submit", function (e) {
      e.preventDefault();
      hideError(loginErrorBox);

      // Second click, after the first submit revealed this is a legacy
      // account with no password set — this click sends the OTP.
      if (flow.mode === "setup" && pendingSetupPhone) {
        setBusy(loginSubmitBtn, true, ACCOUNT_UI.SENDING);
        startForgotFlow(pendingSetupPhone, { skipRequestStep: true });
        return;
      }

      if (!isValidPhoneNumber(loginPhoneInput)) {
        loginPhoneInput.setCustomValidity(invalidPhoneMessage(loginPhoneInput));
        loginPhoneInput.reportValidity();
        return;
      }
      loginPhoneInput.setCustomValidity("");

      if (!loginPasswordInput.value) {
        showError(loginErrorBox, VALIDATION.MISSING_PASSWORD);
        return;
      }

      const phone = buildPhone(loginCountrySelect, loginPhoneInput);
      const username = base64EncodeUtf8(phone);
      const password = base64EncodeUtf8(loginPasswordInput.value);

      setBusy(loginSubmitBtn, true, "Logging in…");

      apiPost(LOGIN, { username: username, password: password })
        .then(function (res) {
          const data = res.data || {};
          if (data.requiresPasswordSetup) {
            enterPasswordSetupMode(phone);
            return;
          }

          if (res.ok && data.result && data.result.accessToken) {
            if (window.AccountAuth) {
              window.AccountAuth.setSession(
                data.result.accessToken,
                data.result.refreshToken,
              );
            }
            loginPasswordInput.value = ""; // clear before navigating away
            window.location.replace(accountRedirectUrl);
            return;
          }

          showError(
            loginErrorBox,
            friendlyError(data.message) || LOGIN_MSG.FAILED,
          );
        })
        .catch(function () {
          showError(loginErrorBox, GENERIC.NETWORK_ERROR);
        })
        .finally(function () {
          setBusy(loginSubmitBtn, false);
        });
    });
  }

  root
    .querySelectorAll('[data-action="go-forgot-request"]')
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        flow.mode = "forgot";
        showStep("forgot-request");
      });
    });

  // STEP: PASSWORDLESS OTP LOGIN

  const otpLoginState = {
    phone: "",
    session: "",
  };

  root
    .querySelectorAll('[data-action="go-otp-login-request"]')
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        showStep("otp-login-request");
      });
    });

  const otpLoginPhoneInput = document.getElementById("OtpLoginPhone");
  const otpLoginCountrySelect = document.getElementById("OtpLoginCountryCode");
  const otpLoginRequestErrorBox = root.querySelector(
    '[data-step="otp-login-request"] [data-otp-login-request-error]',
  );
  const otpLoginRequestBtn = root.querySelector(
    '[data-action="request-login-otp"]',
  );

  wireEnableOnFill(otpLoginRequestBtn, [otpLoginPhoneInput]);

  if (otpLoginPhoneInput) digitsOnly(otpLoginPhoneInput);
  wireCountryPhoneSync(
    otpLoginCountrySelect,
    root.querySelector(
      '[data-step="otp-login-request"] [data-country-display]',
    ),
    otpLoginPhoneInput,
  );

  function requestLoginOtp(phone) {
    return apiPost(LOGIN_OTP_REQUEST, { username: phone });
  }

  if (otpLoginRequestBtn) {
    otpLoginRequestBtn.addEventListener("click", function () {
      hideError(otpLoginRequestErrorBox);

      if (!isValidPhoneNumber(otpLoginPhoneInput)) {
        otpLoginPhoneInput.setCustomValidity(
          invalidPhoneMessage(otpLoginPhoneInput),
        );
        otpLoginPhoneInput.reportValidity();
        return;
      }
      otpLoginPhoneInput.setCustomValidity("");

      const phone = buildPhone(otpLoginCountrySelect, otpLoginPhoneInput);

      setBusy(otpLoginRequestBtn, true, ACCOUNT_UI.SENDING);

      requestLoginOtp(phone)
        .then(function (res) {
          if (!res.ok) {
            showError(
              otpLoginRequestErrorBox,
              (res.data && res.data.message) || OTP.SEND_FAILED,
            );
            return;
          }

          otpLoginState.phone = phone;
          otpLoginState.session = res.data.session;

          otpLoginBoxGroup.reset();
          hideError(otpLoginErrorBox);
          if (res.data.message) {
            showSuccess(otpLoginSuccessBox, OTP.SENT_TO(phone));
          }
          showStep("otp-login-verify");
          otpLoginBoxGroup.focusBox(0);
          startResendCountdown(otpLoginResendBtn, RESEND_COOLDOWN_MS);
        })
        .catch(function () {
          showError(otpLoginRequestErrorBox, GENERIC.NETWORK_ERROR);
        })
        .finally(function () {
          setBusy(otpLoginRequestBtn, false);
        });
    });
  }

  const otpLoginVerifyStepEl = root.querySelector(
    '[data-step="otp-login-verify"]',
  );
  const otpLoginHiddenInput = document.getElementById("LoginOtp");
  const otpLoginErrorBox = root.querySelector("[data-otp-login-error]");
  const otpLoginSuccessBox = root.querySelector("[data-otp-login-success]");
  const otpLoginVerifyBtn = root.querySelector(
    '[data-action="verify-login-otp"]',
  );
  const otpLoginResendBtn = root.querySelector(
    '[data-action="resend-login-otp"]',
  );
  const otpLoginChangeNumberBtn = root.querySelector(
    '[data-action="change-otp-login-number"]',
  );

  let updateOtpLoginVerifyBtnState = function () {};

  const otpLoginBoxGroup = otpLoginVerifyStepEl
    ? makeOtpBoxGroup(otpLoginVerifyStepEl, otpLoginHiddenInput, function () {
        updateOtpLoginVerifyBtnState();
      })
    : {
        boxes: [],
        updateHidden: function () {},
        focusBox: function () {},
        reset: function () {},
      };

  updateOtpLoginVerifyBtnState = wireEnableOnFill(
    otpLoginVerifyBtn,
    otpLoginBoxGroup.boxes,
  );
  updateOtpLoginVerifyBtnState();

  if (otpLoginChangeNumberBtn) {
    otpLoginChangeNumberBtn.addEventListener("click", function () {
      showStep("otp-login-request");
    });
  }

  if (otpLoginResendBtn) {
    otpLoginResendBtn.addEventListener("click", function () {
      if (!otpLoginState.phone) return;

      const labelEl = otpLoginResendBtn.querySelector("[data-btn-label]");
      if (labelEl && !otpLoginResendBtn.dataset.idleLabel) {
        otpLoginResendBtn.dataset.idleLabel = labelEl.textContent;
      }

      otpLoginResendBtn.disabled = true;
      if (labelEl) labelEl.textContent = ACCOUNT_UI.SENDING;

      requestLoginOtp(otpLoginState.phone)
        .then(function (res) {
          if (!res.ok) {
            showError(
              otpLoginErrorBox,
              (res.data && res.data.message) || OTP.RESEND_FAILED,
            );
            if (labelEl)
              labelEl.textContent = otpLoginResendBtn.dataset.idleLabel;
            otpLoginResendBtn.disabled = false;
            return;
          }

          otpLoginState.session = res.data.session;

          otpLoginBoxGroup.reset();
          otpLoginBoxGroup.focusBox(0);
          hideError(otpLoginErrorBox);
          showSuccess(otpLoginSuccessBox, OTP.RESENT);

          startResendCountdown(otpLoginResendBtn, RESEND_COOLDOWN_MS);
        })
        .catch(function () {
          showError(otpLoginErrorBox, OTP.RESEND_FAILED);
          if (labelEl)
            labelEl.textContent = otpLoginResendBtn.dataset.idleLabel;
          otpLoginResendBtn.disabled = false;
        });
    });
  }

  if (otpLoginVerifyBtn) {
    otpLoginVerifyBtn.addEventListener("click", function () {
      otpLoginBoxGroup.updateHidden();

      if (!/^\d{6}$/.test(otpLoginHiddenInput.value)) {
        showError(otpLoginErrorBox, VALIDATION.INVALID_OTP);
        const firstEmpty = otpLoginBoxGroup.boxes.findIndex(function (box) {
          return !box.value;
        });
        otpLoginBoxGroup.focusBox(firstEmpty === -1 ? 0 : firstEmpty);
        return;
      }

      hideError(otpLoginErrorBox);
      setBusy(otpLoginVerifyBtn, true, ACCOUNT_UI.VERIFYING);

      apiPost(LOGIN_OTP_VERIFY, {
        phone_number: otpLoginState.phone,
        otp: otpLoginHiddenInput.value,
        session: otpLoginState.session,
      })
        .then(function (res) {
          const data = res.data || {};

          if (res.ok && data.AccessToken) {
            if (window.AccountAuth) {
              window.AccountAuth.setSession(
                data.AccessToken,
                data.RefreshToken,
              );
            }
            window.location.replace(accountRedirectUrl);
            return;
          }

          showError(
            otpLoginErrorBox,
            friendlyError(data.message) || LOGIN_MSG.OTP_VERIFY_FAILED,
          );
        })
        .catch(function () {
          showError(otpLoginErrorBox, GENERIC.NETWORK_ERROR);
        })
        .finally(function () {
          setBusy(otpLoginVerifyBtn, false);
        });
    });
  }

  // STEP: FORGOT PASSWORD — REQUEST OTP

  const forgotPhoneInput = document.getElementById("ForgotPhone");
  const forgotCountrySelect = document.getElementById("ForgotCountryCode");
  const forgotRequestErrorBox = root.querySelector(
    '[data-step="forgot-request"] [data-forgot-request-error]',
  );
  const requestOtpBtn = root.querySelector('[data-action="request-otp"]');

  wireEnableOnFill(requestOtpBtn, [forgotPhoneInput]);

  if (forgotPhoneInput) digitsOnly(forgotPhoneInput);
  wireCountryPhoneSync(
    forgotCountrySelect,
    root.querySelector('[data-step="forgot-request"] [data-country-display]'),
    forgotPhoneInput,
  );

  function requestOtp(phone) {
    return apiPost(FORGOT_PASSWORD, { username: phone });
  }
  function startForgotFlow(phone, options) {
    options = options || {};
    flow.phone = phone;

    if (!options.skipRequestStep) {
      enterOtpStep(phone);
      return;
    }

    requestOtp(phone)
      .then(function (res) {
        setBusy(loginSubmitBtn, false);
        if (!res.ok) {
          enterOtpStep(phone);
          showError(otpErrorBox, res.data.message || OTP.SEND_FAILED_SILENT);
          return;
        }
        enterOtpStep(phone, res.data.message);
      })
      .catch(function () {
        setBusy(loginSubmitBtn, false);
        enterOtpStep(phone);
        showError(otpErrorBox, OTP.SEND_FAILED_SILENT);
      });
  }

  function enterOtpStep(phone, successMessage) {
    const titleEl = root.querySelector(
      '[data-step="forgot-otp"] [data-otp-title]',
    );
    const descEl = root.querySelector(
      '[data-step="forgot-otp"] [data-forgot-desc]',
    );

    if (titleEl) {
      titleEl.textContent =
        flow.mode === "setup"
          ? ACCOUNT_UI.SET_YOUR_PASSWORD_TITLE
          : ACCOUNT_UI.RESET_YOUR_PASSWORD_TITLE;
    }
    if (descEl) {
      descEl.textContent = "Enter the 6-digit code sent to " + phone;
    }

    resetOtpBoxes();
    if (successMessage) {
      showSuccess(otpSuccessBox, successMessage);
    }
    showStep("forgot-otp");
    focusOtpBox(0);
    startResendCountdown(resendBtn, RESEND_COOLDOWN_MS);
  }

  if (requestOtpBtn) {
    requestOtpBtn.addEventListener("click", function () {
      hideError(forgotRequestErrorBox);

      if (!isValidPhoneNumber(forgotPhoneInput)) {
        forgotPhoneInput.setCustomValidity(
          invalidPhoneMessage(forgotPhoneInput),
        );
        forgotPhoneInput.reportValidity();
        return;
      }
      forgotPhoneInput.setCustomValidity("");

      const phone = buildPhone(forgotCountrySelect, forgotPhoneInput);
      flow.mode = "forgot";

      setBusy(requestOtpBtn, true, ACCOUNT_UI.SENDING);

      requestOtp(phone)
        .then(function (res) {
          if (!res.ok) {
            showError(
              forgotRequestErrorBox,
              res.data.message || OTP.SEND_FAILED,
            );
            return;
          }
          flow.phone = phone;
          enterOtpStep(phone, res.data.message);
        })
        .catch(function () {
          showError(forgotRequestErrorBox, GENERIC.NETWORK_ERROR);
        })
        .finally(function () {
          setBusy(requestOtpBtn, false);
        });
    });
  }

  // STEP: FORGOT PASSWORD — VERIFY OTP

  const otpBoxes = Array.prototype.slice.call(
    root.querySelectorAll('[data-step="forgot-otp"] [data-otp-box]'),
  );
  const otpHiddenInput = document.getElementById("ForgotOtp");
  const otpErrorBox = root.querySelector("[data-otp-error]");
  const otpSuccessBox = root.querySelector("[data-otp-success]");
  const resendBtn = root.querySelector('[data-action="resend-otp"]');
  const changeNumberBtn = root.querySelector('[data-action="change-number"]');
  const continueBtn = root.querySelector('[data-action="continue-to-reset"]');

  function updateOtpHidden() {
    if (!otpHiddenInput) return;
    otpHiddenInput.value = otpBoxes
      .map(function (box) {
        return box.value;
      })
      .join("");
  }

  function focusOtpBox(index) {
    if (otpBoxes[index]) otpBoxes[index].focus();
  }

  function resetOtpBoxes() {
    otpBoxes.forEach(function (box) {
      box.value = "";
    });
    updateOtpHidden();
    updateContinueBtnState();
    hideError(otpErrorBox);
    hideSuccess(otpSuccessBox);
  }

  const updateContinueBtnState = wireEnableOnFill(continueBtn, otpBoxes);

  otpBoxes.forEach(function (box, index) {
    box.addEventListener("input", function () {
      this.value = this.value.replace(/\D/g, "").slice(0, 1);
      updateOtpHidden();
      updateContinueBtnState();
      hideError(otpErrorBox);
      if (this.value && index < otpBoxes.length - 1) {
        focusOtpBox(index + 1);
      }
    });

    box.addEventListener("keydown", function (e) {
      if (e.key === "Backspace" && !this.value && index > 0) {
        focusOtpBox(index - 1);
      }
    });

    box.addEventListener("paste", function (e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData)
        .getData("text")
        .replace(/\D/g, "")
        .slice(0, otpBoxes.length);
      pasted.split("").forEach(function (digit, i) {
        if (otpBoxes[i]) otpBoxes[i].value = digit;
      });
      updateOtpHidden();
      updateContinueBtnState();
      hideError(otpErrorBox);
      focusOtpBox(Math.min(pasted.length, otpBoxes.length - 1));
    });
  });

  if (changeNumberBtn) {
    changeNumberBtn.addEventListener("click", function () {
      showStep("forgot-request");
    });
  }

  if (resendBtn) {
    resendBtn.addEventListener("click", function () {
      if (!flow.phone) return;

      const labelEl = resendBtn.querySelector("[data-btn-label]");
      if (labelEl && !resendBtn.dataset.idleLabel) {
        resendBtn.dataset.idleLabel = labelEl.textContent;
      }

      resendBtn.disabled = true;
      if (labelEl) labelEl.textContent = ACCOUNT_UI.SENDING;

      requestOtp(flow.phone)
        .then(function (res) {
          if (!res.ok) {
            showError(otpErrorBox, res.data.message || OTP.RESEND_FAILED);
            if (labelEl) labelEl.textContent = resendBtn.dataset.idleLabel;
            resendBtn.disabled = false;
            return;
          }

          resetOtpBoxes();
          focusOtpBox(0);
          showSuccess(otpSuccessBox, res.data.message || OTP.RESENT);

          startResendCountdown(resendBtn, RESEND_COOLDOWN_MS);
        })
        .catch(function () {
          showError(otpErrorBox, OTP.RESEND_FAILED);
          if (labelEl) labelEl.textContent = resendBtn.dataset.idleLabel;
          resendBtn.disabled = false;
        });
    });
  }

  if (continueBtn) {
    continueBtn.addEventListener("click", function () {
      updateOtpHidden();

      if (!/^\d{6}$/.test(otpHiddenInput.value)) {
        showError(otpErrorBox, VALIDATION.INVALID_OTP);
        const firstEmpty = otpBoxes.findIndex(function (box) {
          return !box.value;
        });
        focusOtpBox(firstEmpty === -1 ? 0 : firstEmpty);
        return;
      }

      hideError(otpErrorBox);
      flow.otp = otpHiddenInput.value;
      enterResetStep();
    });
  }

  // STEP: SET / RESET PASSWORD
  const newPasswordInput = document.getElementById("NewPassword");
  const confirmPasswordInput = document.getElementById("ConfirmPassword");
  const resetErrorBox = root.querySelector("[data-reset-error]");
  const resetBtn = root.querySelector('[data-action="reset-password"]');
  const resetPhoneHidden = document.getElementById("ResetPasswordPhone");
  const resetOtpHidden = document.getElementById("ResetPasswordOtp");

  wireEnableOnFill(resetBtn, [newPasswordInput, confirmPasswordInput]);

  function enterResetStep() {
    const titleEl = root.querySelector(
      '[data-step="reset"] [data-reset-title]',
    );
    if (titleEl) {
      titleEl.textContent =
        flow.mode === "setup"
          ? ACCOUNT_UI.SET_YOUR_PASSWORD_TITLE
          : ACCOUNT_UI.RESET_YOUR_PASSWORD_TITLE;
    }
    if (resetPhoneHidden) resetPhoneHidden.value = flow.phone;
    if (resetOtpHidden) resetOtpHidden.value = flow.otp;
    hideError(resetErrorBox);
    showStep("reset");
  }

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      hideError(resetErrorBox);

      if (newPasswordInput.value.length < 8) {
        showError(resetErrorBox, VALIDATION.PASSWORD_TOO_SHORT);
        return;
      }
      if (newPasswordInput.value !== confirmPasswordInput.value) {
        showError(resetErrorBox, VALIDATION.PASSWORDS_DO_NOT_MATCH);
        return;
      }

      setBusy(resetBtn, true, ACCOUNT_UI.SAVING);

      apiPost(RESET_PASSWORD, {
        username: flow.phone,
        confirmationCode: flow.otp,
        password: newPasswordInput.value,
        confirmNewPassword: confirmPasswordInput.value,
      })
        .then(function (res) {
          if (!res.ok) {
            showError(resetErrorBox, res.data.message || RESET_MSG.FAILED);
            return;
          }

          // Clear sensitive fields from memory/DOM before navigating away.
          newPasswordInput.value = "";
          confirmPasswordInput.value = "";
          flow.otp = "";

          window.location.href = "/pages/login?message=password-reset";
        })
        .catch(function () {
          showError(resetErrorBox, GENERIC.NETWORK_ERROR);
        })
        .finally(function () {
          setBusy(resetBtn, false);
        });
    });
  }

  // BACK TO LOGIN (from any other step)
  root
    .querySelectorAll('[data-action="back-to-login"]')
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        showStep("login");
        resetPasswordSetupState();
      });
    });

  // PASSWORD VISIBILITY TOGGLES (shared across all password fields)
  root
    .querySelectorAll("[data-login-password-toggle]")
    .forEach(function (toggle) {
      const wrap = toggle.closest(".login-password-wrap");
      const input = wrap ? wrap.querySelector("input") : null;
      if (!input) return;

      toggle.addEventListener("click", function () {
        const isCurrentlyHidden = input.type === "password";
        input.type = isCurrentlyHidden ? "text" : "password";

        const openEye = toggle.querySelector("[data-eye-open]");
        const closedEye = toggle.querySelector("[data-eye-closed]");

        if (isCurrentlyHidden) {
          if (openEye) openEye.style.display = "block";
          if (closedEye) closedEye.style.display = "none";
          toggle.setAttribute("aria-label", "Hide password");
        } else {
          if (openEye) openEye.style.display = "none";
          if (closedEye) closedEye.style.display = "block";
          toggle.setAttribute("aria-label", "Show password");
        }
      });
    });

  // ALREADY LOGGED IN? (fallback check)

  if (window.AccountAuth && window.AccountAuth.getAccessToken()) {
    window.AccountAuth.ensureValidToken().then(function (token) {
      if (token) {
        window.location.replace(accountRedirectUrl);
      }
    });
  }
})();
